import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dropdown } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './styles/DropDownSelectors.styles';

const DropdownLabel = themeStyles.apply(Box, 'DropdownLabel');
const SelectorWrapper = themeStyles.apply(Box, 'SelectorWrapper');

const DropDownSelector = ({ dropdown, options, parentNode, currentNodes, index, handleChange, selectedOptions }) => {
  const { t } = useTranslation();
  return (
    <SelectorWrapper>
      <DropdownLabel disabled={!parentNode} htmlFor={t(dropdown.label)}>
        {t(dropdown.label)}
      </DropdownLabel>
      <Dropdown
        options={options}
        onChange={value => handleChange(value, currentNodes, index, dropdown)}
        ariaLabel={t(dropdown.label)}
        name={dropdown.name}
        disabled={!parentNode}
        width={dropdown.width}
        value={selectedOptions[index]?.data?.value}
        placeholderText={t(dropdown.placeholder)}
        dataTestId={`cy-dropdown-${dropdown.name}`}
      />
    </SelectorWrapper>
  );
};

DropDownSelector.propTypes = {
  dropdown: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    ariaLabel: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  }),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  parentNode: PropTypes.shape({}),
  currentNodes: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number,
  handleChange: PropTypes.func,
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  ),
};

export default DropDownSelector;
